const baseConfig = {};
const devConfig = {
  baseURL: 'https://superx.irunbird.com/share_admin',
};

const proConfig = {
  baseURL: 'https://api.ymbcsaas.com/share_admin',
};

const config = {
  ...baseConfig,
  ...(process.env.NODE_ENV === 'production' ? proConfig : devConfig)
}

export default config;